import React from "react";

import RequestUpdateFrom from "components/RequestUpdateForm";

const RequestUpdateFromPage = () => {
  return <RequestUpdateFrom />;
};

export default RequestUpdateFromPage;
